module.exports = __webpack_public_path__ + "static/media/english-flag.0de2e412.png";